export interface DsMultiSelectOptionBase<T extends string | number = string | number> {
    id: string | number;
    value: T;
    label: string;
    tooltipText?: string;
    disabled?: boolean;
}

export interface DsMultiSelectGroup<T> {
    label: string;
    items: T[];
}

export interface DsMultiSelectSlotProps<T> {
    option: T & DsMultiSelectOptionBase;
    isSelected: boolean;
}

export interface DsMultiSelectGroupedOption<T> {
    label?: string;
    items: (T & DsMultiSelectOptionBase)[];
}

export interface DsMultiSelectProps<T> {
    id: string;
    label?: string;
    options: (DsMultiSelectOptionBase & T)[];
    placeholder: string;
    modelValue: T[];
    groupLabel?: string | keyof (DsMultiSelectOptionBase & T);
    searchInputPlaceholder?: string;
    error?: string | boolean;
    helperText?: string;
    required?: boolean;
    isFullWidth?: boolean;
    disabled?: boolean;
    disableSelectAll?: boolean;
    showSelectAll?: boolean;
}

export interface DsMultiSelectOptionProps {
    isSelected: boolean;
    disabled?: boolean;
}

export enum SelectAllState {
    Unchecked = 'unchecked',
    Checked = 'checked',
    Indeterminate = 'indeterminate',
}
